import React from 'react';
import { NavLink } from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiHome, FiPalette, FiUsers, FiSettings, FiLogOut, FiMenu, FiShoppingBag, FiMonitor, FiCreditCard, FiMapPin, FiGrid, FiPrinter } = FiIcons;

const AdminSidebar = () => {
  const menuItems = [
    { path: '/admin', icon: FiHome, label: 'Dashboard', exact: true },
    { path: '/admin/kitchen', icon: FiMonitor, label: 'Kitchen Display' },
    { path: '/admin/orders', icon: FiShoppingBag, label: 'Order Management' },
    { path: '/admin/locations', icon: FiMapPin, label: 'Locations' },
    { path: '/admin/categories', icon: FiGrid, label: 'Categories' },
    { path: '/admin/menu', icon: FiMenu, label: 'Menu Management' },
    { path: '/admin/theme', icon: FiPalette, label: 'Theme Settings' },
    { path: '/admin/payments', icon: FiCreditCard, label: 'Payment Settings' },
    { path: '/admin/printers', icon: FiPrinter, label: 'Printer Settings' },
    { path: '/admin/users', icon: FiUsers, label: 'User Management' },
    { path: '/admin/settings', icon: FiSettings, label: 'Settings' }
  ];

  return (
    <div className="w-64 bg-warm-brown text-cream flex flex-col">
      <div className="p-6 border-b border-cream/20">
        <img 
          src="https://cdn1.sharemyimage.com/smi/2025/10/21/Logo-Lavie-Saigon.jpeg" 
          alt="La Vie Saigon" 
          className="h-12 w-auto mb-2" 
        />
        <h2 className="text-xl font-playfair">Admin Panel</h2>
      </div>

      <nav className="flex-1 p-4">
        <ul className="space-y-2">
          {menuItems.map((item) => (
            <li key={item.path}>
              <NavLink
                to={item.path}
                end={item.exact}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-4 py-3 rounded-lg transition-colors duration-200 ${
                    isActive
                      ? 'bg-cream/20 text-cream'
                      : 'text-cream/80 hover:bg-cream/10 hover:text-cream'
                  }`
                }
              >
                <SafeIcon icon={item.icon} className="text-lg" />
                {item.label}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>

      <div className="p-4 border-t border-cream/20">
        <NavLink
          to="/login"
          className="flex items-center gap-3 px-4 py-3 text-cream/80 hover:bg-cream/10 hover:text-cream rounded-lg transition-colors duration-200"
        >
          <SafeIcon icon={FiLogOut} className="text-lg" />
          Logout
        </NavLink>
      </div>
    </div>
  );
};

export default AdminSidebar;